module.exports = __webpack_public_path__ + "img/takane.e408297e.jpg";